<template>
  <div
    v-if="isMobileScreenSize"
    class="fixed top-0 left-0 w-screen h-full table bg-black-50 z-10"
  >
    <div id="outside" class="table-cell align-bottom">
      <div
        ref="modalContents"
        class="modal-container rounded-lg m-auto bg-white"
        role="dialog"
        aria-modal="true"
        aria-label="Confirm"
      >
        <div
          class="flex flex-col rounded-t px-16 justify-between items-center py-24 gap-32 w-screen"
        >
          <Form
            class="flex flex-col gap-16 w-full"
            :validator="$v.model"
            :error="error"
          >
            <H2 class="font-bold mt-8 self-center">
              {{ $t('health_actions.scheduling.change_zip_code_title') }}
            </H2>
            <Body class="text-grey-500 font-semibold">
              {{ $t('common.zip_code') }}
            </Body>
            <FormInput
              v-model="model.zipCode"
              mask="#####"
              name="zipCode"
              :placeholder="
                $t('health_actions.scheduling.zip_code_placeholder')
              "
              autocomplete="postal-code"
            />
          </Form>
          <div class="flex flex-col items-center gap-16 w-full">
            <HMButton rounded="full" class="w-full" @click="saveZipCode">
              {{ $t('common.update') }}
            </HMButton>
            <HMButton
              rounded="full"
              outlined
              class="w-full button--white-outlined"
              @click="$emit('close-zip-code-modal')"
            >
              {{ $t('common.cancel_btn') }}
            </HMButton>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-else-if="!isMobileScreenSize"
    :active="true"
    :shouldFocusFirstElement="false"
    :closeOnBackDrop="true"
    @close="$emit('close-zip-code-modal')"
    ><div
      class="flex-1 flex flex-col h-full fixed top-0 right-0 bg-white-100 bottom-0 w-435 m-0 border-0"
    >
      <div
        class="border-b border-grey-300 flex justify-between items-center p-24"
      >
        <H2 class="font-bold">
          {{ $t('health_actions.scheduling.change_zip_code_title') }}
        </H2>
        <button class="text-grey-500" @click="$emit('close-zip-code-modal')">
          <span class="text-4xl">&times;</span>
        </button>
      </div>
      <Form class="p-24 flex-1" :validator="$v.model" :error="error">
        <div class="flex flex-col flex-grow gap-8">
          <Body class="text-grey-500 font-semibold">
            {{ $t('health_actions.scheduling.zip_code_label') }}
          </Body>
          <FormInput
            v-model="model.zipCode"
            mask="#####"
            name="zipCode"
            :placeholder="$t('health_actions.scheduling.zip_code_placeholder')"
            autocomplete="postal-code"
          />
        </div>
      </Form>
      <div class="flex w-full justify-between border-t border-grey-300 p-24">
        <HMButton
          rounded="full"
          outlined
          class="flex-1 button--white-outlined mr-24"
          @click="$emit('close-zip-code-modal')"
        >
          {{ $t('common.cancel_btn') }}
        </HMButton>
        <HMButton rounded="full" class="flex-1 " @click="saveZipCode">
          {{ $t('common.update') }}
        </HMButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '~/components/common/Modal.vue'
import Body from '~/components/common/Typography/Body.vue'
import H2 from '~/components/common/Typography/H2.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { Form, FormInput } from '../../../../common/forms'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Modal,
    H2,
    Body,
    Form,
    FormInput,
  },
  mixins: [screenSizeMixin],
  data() {
    return {
      model: {
        zipCode: '',
      },
      error: null,
    }
  },
  validations: {
    model: {
      zipCode: {
        required,
        validZipCode() {
          return this.model.zipCode.length === 5
        },
      },
    },
  },
  computed: {
    ...mapGetters('scheduling', ['getDoctorPreferences', 'zipCode']),
  },
  methods: {
    ...mapActions('scheduling', ['setZipCode', 'fetchProviders']),
    saveZipCode() {
      this.error = null
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.$emit('close-zip-code-modal')
      this.setZipCode(this.model.zipCode)
      this.fetchProviders({
        distance: this.getDoctorPreferences.distance,
        providerGender: this.getDoctorPreferences.gender,
        address: this.model.zipCode,
      })
    },
  },
}
</script>
